<template>
  <div v-if="ncstraining" class="mx-auto">
    <staff-ncs-training-lecture-view :ncstraining="ncstraining" v-if="mode==='VIEW'" @lecture-edit="onLectureEdit"/>
    <staff-ncs-training-lecture-edit :lecture="lecture" v-else @mode-change="mode='VIEW'"/>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import NcsTraining from '@/models/NcsTraining'
import StaffNcsTrainingLectureView from './StaffNcsTrainingLectureView.vue'
import StaffNcsTrainingLectureEdit from './StaffNcsTrainingLectureEdit.vue'
export default {
  name: 'StaffNcsTrainingLecture',
  components: { StaffNcsTrainingLectureView, StaffNcsTrainingLectureEdit },
  props: ['ncstraining'],
  data: () => ({
    TAG: 'StaffNcsTrainingLecture',
    mode: 'VIEW',
    lecture: {}
  }),
  methods: {
    onLectureEdit (lecture) {
      this.lecture = lecture
      this.mode = 'EDIT'
    },
    onBack () {
      this.$router.back()
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      this.ncstraining = await this.ncstraining.save()
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      await this.ncstraining.delete()
      this.$router.back()
    },
    onActiveTab (index) {
    }
  }
}
</script>
